import type { ReactNode } from 'react';

export type ConnectStep = { title: ReactNode; description: ReactNode };
export type ConnectStepsProps = {
  steps: ConnectStep[];
  /** Índice (0) do passo atual; os passos até ele ficam destacados (`on`). */
  current: number;
};

/** Passo a passo da conexão (`.fin-steps`). */
export function ConnectSteps({ steps, current }: ConnectStepsProps) {
  return (
    <ol className="fin-steps" style={{ padding: 0 }}>
      {steps.map((s, i) => (
        <li key={i} className={i <= current ? 'on' : undefined} aria-current={i === current ? 'step' : undefined}>
          <i>{i + 1}</i>
          <div><b>{s.title}</b><small>{s.description}</small></div>
        </li>
      ))}
    </ol>
  );
}
